"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAggregationRules = void 0;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var extremum = {
  apply: function getExtremum(_ref) {
    var values = _ref.values;
    if (values.length === 0) {
      return null;
    }
    var max = -Infinity;
    var min = +Infinity;
    for (var i = 0; i < values.length; i += 1) {
      var value = values[i];
      if (value != null) {
        if (value > max) {
          max = value;
        }
        if (value < min) {
          min = value;
        }
      }
    }
    return {
      max: max,
      min: min
    };
  },
  columnTypes: ['number', 'percent', 'currency']
};
var _aggregationFunctions = {
  extremum: extremum
};
var getAggregationRules = exports.getAggregationRules = function getAggregationRules(_ref2) {
  var columnsLookup = _ref2.columnsLookup,
    aggregationModel = _ref2.aggregationModel;
  var aggregationRules = {};
  // console.log('applyAggregation.getAggregationRules',{ columnsLookup,
  //   aggregationModel,})
  Object.entries(aggregationModel).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      field = _ref4[0],
      columnItem = _ref4[1];
    var aggregation = _aggregationFunctions[columnItem];
    var colDef = columnsLookup[field];
    // console.log('applyAggregation.aggregation', {field, aggregation, colDef})
    if (colDef && aggregation.columnTypes.includes(colDef.columnType)) {
      aggregationRules[field] = _aggregationFunctions[columnItem].apply;
    }
  });
  return aggregationRules;
};